<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">CUSTOM SETTINGS</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
    <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="container">
    <div class="row">
    <div class="col-12">
        <div class="modal-body" [formGroup]="item.formGroup">
            <div class="py-2 px-3">
                <div class="mb-3">
                    <div class="d-flex right w-50">
                        <div class="btn-group">
                            <button [ngClass]="item.adjSign === '-' ? 'btn-secondary' : 'btn-outline-secondary'"
                                class="btn" (click)="item.ruleChanged = item.ruleChanged || item.adjSign != '-';item.adjSign = '-';">-</button>
                            <button [ngClass]="item.adjSign === '+' ? 'btn-secondary' : 'btn-outline-secondary'"
                                class="btn" (click)="item.ruleChanged = item.ruleChanged || item.adjSign != '+';item.adjSign = '+'">+</button>
                        </div>
                        <div class="input-group ml-3">
                            <input class="form-control" type="number" min="0" formControlName="adjustment">
                            <div class="input-group-append">
                                <span class="input-group-text">%</span>
                            </div>
                        </div>
                    </div>
                    <div class="py-2"
                    ngbPopover="Add or subtract a percentage to your reorder amount."
                    container="body" placement="top" triggers="manual" #p17="ngbPopover"
                    style="width:100px">Adjustment
                    <i class="fa fa-question fa-qus" (mouseenter)="p17.open()" (mouseleave)="p17.close()"></i>
                    </div>
                </div>
            </div>
            <div class="py-2 px-3">
                <div class="right pt-2">
                    <span class="kt-switch kt-switch--sm kt-switch--icon ml-2">
                        <label style="display: inline;">
                            <input type="checkbox" formControlName="minusInventory">
                            <span></span>
                        </label>
                    </span>
                </div>
                <div ngbPopover="Select to deduct from your reorder amount the inventory from your selected locations."
                container="body" placement="top" triggers="manual" #p18="ngbPopover" style="width:115px">
                    Minus inventory
                    <i class="fa fa-question fa-qus" (mouseenter)="p18.open()" (mouseleave)="p18.close()"></i>
                    <div ngbDropdown container="body" class="w-50">
                        <div ngbDropdownToggle class="hide kt-font-brand cursor-pointer">Select locations</div>
                        <div ngbDropdownMenu class="p-3">
                            <ng-container *ngIf="item.locationsFormGroup" [formGroup]="item.locationsFormGroup">
                                <div class="d-flex" *ngFor="let location of locations.getAll()">
                                    <span class="kt-switch kt-switch--xs kt-switch--icon ml-2">
                                        <label style="display: unset;">
                                            <input type="checkbox" [id]="'loc' + location.id" [formControlName]="location.id">
                                            <span></span>
                                        </label>
                                    </span>
                                    <div class="p-1">
                                        <label [attr.for]="'loc' + location.id" style="display: unset;">{{location.name}}</label>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>                    
                </div>
            </div>
            <div class="py-2 px-3">
                <div class="right pt-2">
                    <span class="kt-switch kt-switch--sm kt-switch--icon ml-2">
                        <label style="display: inline;">
                            <input type="checkbox" formControlName="minusStoreInventory">
                            <span></span>
                        </label>
                    </span>
                </div>
                <div>
                    Minus store inventory
                    <div ngbDropdown container="body" class="w-50">
                        <div ngbDropdownToggle class="hide kt-font-brand cursor-pointer">Select stores</div>
                        <div ngbDropdownMenu class="p-3">
                            <ng-container *ngIf="item.storesFormGroup" [formGroup]="item.storesFormGroup">
                                <div class="d-flex" *ngFor="let store of stores.getAll()">
                                    <span class="kt-switch kt-switch--xs kt-switch--icon ml-2">
                                        <label style="display: unset;">
                                            <input type="checkbox" [id]="'store' + store.id" [formControlName]="store.id">
                                            <span></span>
                                        </label>
                                    </span>
                                    <div class="p-1">
                                        <label [attr.for]="'store' + store.id" style="display: unset;">{{store.name}}</label>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>                    
                </div>
            </div>
            <div class="py-2 px-3">
                <div class="right pt-2">
                    <span class="kt-switch kt-switch--sm kt-switch--icon ml-2">
                        <label style="display: inline;">
                            <input type="checkbox" formControlName="minusOverstockedStoreInventory"
                                [attr.disabled]="isOverstockedDisabled()">
                            <span></span>
                        </label>
                    </span>
                </div>
                <div>
                    Minus overstocked store inventory
                    <div ngbDropdown container="body" class="w-50">
                        <div ngbDropdownToggle class="hide kt-font-brand cursor-pointer">Select stores</div>
                        <div ngbDropdownMenu class="p-3">
                            <ng-container *ngIf="item.overstockedStoresFormGroup" [formGroup]="item.overstockedStoresFormGroup">
                                <div class="d-flex" *ngFor="let store of stores.getAll()">
                                    <span class="kt-switch kt-switch--xs kt-switch--icon ml-2">
                                        <label style="display: unset;">
                                            <input type="checkbox" [id]="'overstocked-store' + store.id" [formControlName]="store.id"
                                                [attr.disabled]="item.storesFormGroup.value[store.id] ? null : false">
                                            <span></span>
                                        </label>
                                    </span>
                                    <div class="p-1">
                                        <label [attr.for]="'overstocked-store' + store.id" style="display: unset;">{{store.name}}</label>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>                    
                </div>
            </div>
            <div class="p-3">
                <div class="right">
                    <span class="kt-switch kt-switch--sm kt-switch--icon ml-2">
                        <label style="display: inline;">
                            <input type="checkbox" formControlName="minusPOs">
                            <span></span>
                        </label>
                    </span>
                </div>
                <div ngbPopover="Select to deduct from your reorder amount the inventory from your open POs."
                container="body" placement="top" triggers="manual" #p19="ngbPopover" style="width:100px">
                    Minus PO's
                    <i class="fa fa-question fa-qus" (mouseenter)="p19.open()" (mouseleave)="p19.close()"></i>
                </div>
            </div>
            <div class="p-3">
                <div class="right">
                    <span class="kt-switch kt-switch--sm kt-switch--icon ml-2">
                        <label style="display: inline;">
                            <input type="checkbox" formControlName="outOfStock">
                            <span></span>
                        </label>
                    </span>
                </div>
                <div ngbPopover="Select to exclude the days you were out of stock from your reorder calculation."
                container="body" placement="top" triggers="manual" #p20="ngbPopover" style="width:100px">
                    Out of stock
                    <i class="fa fa-question fa-qus" (mouseenter)="p20.open()" (mouseleave)="p20.close()"></i>
                </div>
            </div>
            <div class="p-3">
                <div class="right">
                    <span class="kt-switch kt-switch--sm kt-switch--icon ml-2">
                        <label style="display: inline;">
                            <input type="checkbox" formControlName="buyBox">
                            <span></span>
                        </label>
                    </span>
                </div>
                <div ngbPopover="Select to exclude the days you did not have the buy box."
                container="body" placement="top" triggers="manual" #p21="ngbPopover" style="width:100px">
                    Buy Box
                    <i class="fa fa-question fa-qus" (mouseenter)="p21.open()" (mouseleave)="p21.close()"></i>
                </div>
            </div>
        </div>
    </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Apply</button>
</div>
